"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextCount = void 0;
var tslib_1 = require("tslib");
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_textarea_1 = tslib_1.__importDefault(require("rc-textarea"));
var react_1 = tslib_1.__importStar(require("react"));
var defs_1 = require("../Form/defs");
var ConfigProvider_1 = require("../ConfigProvider");
var utils_1 = require("../utils");
var hooks_1 = require("../utils/hooks");
var input_1 = require("./input");
function TextInput(_a) {
    var valueFromProps = _a.value, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, onChange = _a.onChange, placeholder = _a.placeholder, _c = _a.disabled, disabled = _c === void 0 ? false : _c, size = _a.size, validateStatus = _a.validateStatus, maxCount = _a.maxCount, _d = _a.autoSize, autoSize = _d === void 0 ? false : _d, textareaRef = _a.textareaRef, textareaProps = _a.textareaProps, otherProps = tslib_1.__rest(_a, ["value", "defaultValue", "onChange", "placeholder", "disabled", "size", "validateStatus", "maxCount", "autoSize", "textareaRef", "textareaProps"]);
    var textAreaClassName = ConfigProvider_1.usePrefix('text-area');
    var innerTextAreaClassName = utils_1.concat(textAreaClassName, 'inner');
    var _e = hooks_1.useFocused(textareaProps), focused = _e.focused, focusedHandlers = _e.focusedHandlers;
    var _f = hooks_1.useValue({ valueFromProps: valueFromProps, defaultValue: defaultValue, onChange: onChange }), value = _f.value, setValue = _f.setValue;
    var formInfo = defs_1.useFormInfo();
    var className = classnames_1.default(textAreaClassName, utils_1.concat(textAreaClassName, 'size', size !== null && size !== void 0 ? size : formInfo.size), otherProps.className);
    var inputStyle = input_1.useInputStyle({ focused: focused, validateStatus: validateStatus, size: size, disabled: disabled });
    var innerClassName = classnames_1.default(inputStyle, innerTextAreaClassName);
    var count = getTextCount(value);
    var countView = maxCount != null && (react_1.default.createElement("span", { className: utils_1.concat(textAreaClassName, 'count') },
        count,
        "/",
        maxCount));
    var rcTextareaRef = react_1.useCallback(function (rcTextarea) {
        if (textareaRef != null) {
            utils_1.fillRef(textareaRef, rcTextarea === null || rcTextarea === void 0 ? void 0 : rcTextarea.resizableTextArea.textArea);
        }
    }, [textareaRef]);
    var handleChange = react_1.useCallback(function (e) {
        var _a;
        (_a = textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.onChange) === null || _a === void 0 ? void 0 : _a.call(textareaProps, e);
        setValue(e.target.value);
    }, [textareaProps, setValue]);
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement(rc_textarea_1.default, tslib_1.__assign({}, textareaProps, otherProps, focusedHandlers, { prefixCls: innerTextAreaClassName, className: classnames_1.default(innerClassName, textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.className), ref: rcTextareaRef, disabled: disabled, value: value, placeholder: placeholder, onChange: handleChange, autoSize: autoSize })),
        countView));
}
exports.default = TextInput;
// 获取 unicode 字符数
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/length#unicode
function getTextCount(str) {
    // The string iterator that is used here iterates over characters,
    // not mere code units
    return tslib_1.__spreadArrays(str).length;
}
exports.getTextCount = getTextCount;
//# sourceMappingURL=TextArea.js.map